import { Observable } from 'rxjs'
import { TrackerEventPayload, TrackerHistoryPayloadAsset } from '@app/modules/client/map/shared/models/tracker-history-payload.model'
import { SocketState } from '@app/modules/client/map/shared/abstractSocket.directive'

/**
 * DI token for asset realtime — the surface the map asset consumers use today on v2
 * (SocketAssetsService). A v3 adapter (GoAssetSocketAdapter) implements the same surface so the
 * consumers stay flag-agnostic; a factory swaps the two by FeatureFlagService.realtimeV3.
 */
export abstract class AssetRealtimeGateway {
  abstract socketState$: Observable<SocketState>
  abstract isConnected(state: SocketState): boolean
  abstract subscribe(assetIds: number[]): void
  abstract getCoordinates(): Observable<TrackerHistoryPayloadAsset>
  abstract getEvent(): Observable<TrackerEventPayload>
  abstract close(): void
}
